<template>
  <div class="d-flex-column justify-start blog-page">
    <ScrollProgressBar />
    <div class="d-flex-row space-between">
      <div class="blog-head">
        <div class="d-flex-row justify-start">
          <NuxtLinkLocale class="" :to="'/'"> HOME </NuxtLinkLocale>

          <ArrowRight v-if="blog?.game && blog.game !== null" />

          <NuxtLinkLocale
            v-if="blog?.game && blog.game !== null"
            class=""
            :to="'/blogs'"
          >
            {{ blog.game.short_title }}
          </NuxtLinkLocale>

          <ArrowRight
            v-if="
              blog?.category &&
              blog?.category !== 0 &&
              blog?.category?.title !== ''
            "
          />

          <NuxtLinkLocale
            v-if="blog?.category && blog?.category !== 0"
            class=""
            :to="'/blogs'"
          >
            {{ blog?.category?.title }}
          </NuxtLinkLocale>

          <ArrowRight />

          <a class="t-orange">
            {{ blog?.meta_title }}
          </a>
        </div>

        <p
          class="t-light font-family-2 medium-l"
          v-if="typeof blog?.updated_at !== 'undefined'"
        >
          UPDATED {{ timestampToDateTime(blog?.updated_at) }} |
          <ClockIcon style="padding-top: 5px" />
          {{ timeAgo(blog?.updated_at) }}
        </p>
      </div>
      <div style="width: 100%; max-width: 400px"></div>
    </div>

    <ClientOnly>
      <div class="single-blog">
        <blog-body v-if="blog !== null" :data="blog" />
        <div
          class="b-menu d-flex-column md-hide"
          v-if="blog?.table_of_content?.length > 0"
        >
          <blog-menu
            v-if="blog !== null"
            :tableOfContent="blog.table_of_content || []"
          />
        </div>
      </div>
    </ClientOnly>
  </div>
</template>

<script setup>
import BlogBody from "~/components/custom/BlogBody.vue";
import BlogMenu from "~/components/custom/BlogMenu.vue";
import ArrowRight from "~/components/icons/ArrowRight.vue";
import ScrollProgressBar from "~/components/common/ScrollProgressBar.vue";
import ClockIcon from "~/components/icons/ClockIcon.vue";
import { ref } from "vue";

const blog = ref(null);
const { getLocale } = useFunctions();
const router = useRouter();
const route = router.currentRoute;

const { data: response } = await useApiFetch("/api/get-single-blog", {
  method: "POST",
  fetchKey: "get-single-blog",
  body: {
    locale: getLocale(),
    slug: route.value.params?.blogSlug,
  },
});
// console.log(response.value);
if (response.value?.data) {
  blog.value = response.value?.data;
}
addCanonicalLink(route.value.fullPath);
</script>

<style lang="scss" scoped>
.blog-page {
  padding-left: 100px;
  padding-right: 100px;
  padding-top: 1rem;
  padding-bottom: 1rem;
  @media screen and (min-width: 1441px) {
    padding-left: 120px;
    padding-right: 120px;
  }
  @media screen and (max-width: 850px) {
    padding-left: 50px;
    padding-right: 50px;
  }
  @media screen and (max-width: 768px) {
    padding: 1rem;
    margin-bottom: 60px;
  }
}
</style>
